<!-- CommonInputModal.vue -->
<template>
  <div class="layer_pop_wrap">
    <div class='layer_pop_dim' :style="isVisible ? 'display: block;' : 'display: none'">
      <div class="layer_pop sm" :class="isVisible ? 'active' : ''" tabindex="0">
        <div class="pop_head">
          <h2>{{ title }}</h2>
          <button type="button" class="pop_close" @click="cancel">닫기</button>
        </div>
        <div class="pop_cont">
          <p v-if="message" class="pop_desc">{{ message }}</p>
          
          <div class="form_cont">
            <ul class="column col_1">
              <!-- 여러 입력 필드 지원 -->
              <li v-for="(field, index) in fields" :key="index">
                <div class="label_txt">
                  <span>{{ field.label }}<em v-if="field.required">*</em></span>
                </div>
                <div class="column_input">
                  <input 
                    v-if="field.type === 'text' || field.type === 'password'"
                    :type="field.type"
                    v-model="field.value"
                    :placeholder="field.placeholder"
                    @keyup.enter="confirm"
                    :ref="index === 0 ? 'firstField' : null"
                  />
                  <input 
                    v-else-if="field.type === 'date'"
                    type="date"
                    v-model="field.value"
                    @keyup.enter="confirm"
                    :ref="index === 0 ? 'firstField' : null"
                  />
                  <input 
                    v-else-if="field.type === 'datetime-local'"
                    type="datetime-local"
                    v-model="field.value"
                    @keyup.enter="confirm"
                    :ref="index === 0 ? 'firstField' : null"
                  />
                  <textarea
                    v-else-if="field.type === 'textarea'"
                    v-model="field.value"
                    :placeholder="field.placeholder"
                    :rows="field.rows || 3"
                    :ref="index === 0 ? 'firstField' : null"
                  ></textarea>
                </div>
              </li>
              
              <!-- 단일 입력 필드 (하위 호환성) -->
              <li v-if="!fields.length && inputType">
                <div class="label_txt">
                  <span>{{ label }}</span>
                </div>
                <div class="column_input">
                  <input 
                    v-if="inputType === 'text' || inputType === 'password'"
                    :type="inputType"
                    v-model="inputValue"
                    :placeholder="placeholder"
                    @keyup.enter="confirm"
                    ref="inputField"
                  />
                  <input 
                    v-else-if="inputType === 'date'"
                    type="date"
                    v-model="inputValue"
                    @keyup.enter="confirm"
                    ref="inputField"
                  />
                  <input 
                    v-else-if="inputType === 'datetime-local'"
                    type="datetime-local"
                    v-model="inputValue"
                    @keyup.enter="confirm"
                    ref="inputField"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pop_foot">
          <button type="button" class="sm_btn" @click="cancel">취소</button>
          <button type="button" class="sm_btn color_1" @click="confirm">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonInputModal',
  data() {
    return {
      isVisible: false,
      title: '',
      message: '',
      label: '',
      placeholder: '',
      inputType: null,
      inputValue: '',
      fields: [],
      resolvePromise: null,
      rejectPromise: null
    }
  },
  
  methods: {
    open(options = {}) {
      this.title = options.title || '확인';
      this.message = options.message || '';
      
      // 다중 입력 모드
      if (options.fields && options.fields.length > 0) {
        this.fields = options.fields.map(field => ({
          name: field.name,
          type: field.type || 'text',
          label: field.label || '',
          required: field.required || false,
          placeholder: field.placeholder || '',
          value: field.defaultValue || '',
          rows: field.rows || 3
        }));
        this.inputType = null;
      } 
      // 단일 입력 모드
      else {
        this.label = options.label || '';
        this.placeholder = options.placeholder || '';
        this.inputType = options.inputType || null;
        this.inputValue = options.defaultValue || '';
        this.fields = [];
      }
      
      this.isVisible = true;
      
      this.$nextTick(() => {
        if (this.$refs.firstField && this.$refs.firstField[0]) {
          this.$refs.firstField[0].focus();
        } else if (this.$refs.inputField) {
          this.$refs.inputField.focus();
        }
      });
      
      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    
    confirm() {
      let value;
      
      // 다중 입력 모드
      if (this.fields.length > 0) {
        value = {};
        this.fields.forEach(field => {
          value[field.name] = field.value;
        });
      } 
      // 단일 입력 모드
      else {
        value = this.inputType ? this.inputValue : true;
      }
      
      this.close();
      if (this.resolvePromise) {
        this.resolvePromise(value);
      }
    },
    
    cancel() {
      this.close();
      if (this.resolvePromise) {
        this.resolvePromise(null);
      }
    },
    
    close() {
      this.isVisible = false;
      this.inputValue = '';
      this.fields = [];
    }
  }
}
</script>

<style scoped>
/* 설명 텍스트 스타일 */
.pop_desc {
  padding: 0 20px 20px;
  color: #333;
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
}

/* textarea 스타일 */
.column_input textarea {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  line-height: 1.5;
}

.column_input textarea:focus {
  outline: none;
  border-color: #2196F3;
}

.column_input textarea::placeholder {
  color: #999;
}

/* date, datetime-local input 스타일 보정 */
.column_input input[type="date"],
.column_input input[type="datetime-local"] {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.column_input input[type="date"]:focus,
.column_input input[type="datetime-local"]:focus {
  outline: none;
  border-color: #2196F3;
}

/* 라벨의 필수 표시 */
.label_txt em {
  color: #f44336;
  font-style: normal;
  margin-left: 2px;
}
</style>